import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';



@Injectable()
export class TeamManagerService {
    constructor(
        private httpService: HttpService) { }



    //获取团队管理信息
    //TQQ 2017-01-03
    getSubUsers(param) {
        let url = AppConfig.GetProdUrl() + "/Team/GetSubUsers";
        return this.httpService.post(url, param);
    }

    //当前用户是否可转账
    //TQQ 2018-07-19
    canTransfer() {
        let url = AppConfig.GetProdUrl() + "/User/CanTransfer";
        return this.httpService.get(url);
    }


    //获取返点列表
    //TQQ 2017-01-05

    //修改下级返点
    //chen 2017-01-09
    updateChangeBonus(userName: string, bonus: string) {
        let url = AppConfig.GetProdUrl() + "/Team/EditUserBouns";
        let param = "userName=" + userName + "&bonus=" + bonus;
        return this.httpService.get(url + "?" + param);
    }

    //获得配额分配列表
    //chen 2017-01-09
    getUserLimits(subUserName: string) {
        let url = AppConfig.GetProdUrl() + "/Team/GetUserLimits?subUserName=" + subUserName;
        return this.httpService.get(url);
    }

    //修改配额分配
    //chen 2017-01-09
    updateUserLimit(subUserName:string,bonus:string,limit:string) {
        let url = AppConfig.GetProdUrl() + "/Team/UpdateUserLimit";
        let param="subUserName="+subUserName+"&bonus="+bonus+"&limit="+limit;
        return this.httpService.get(url+"?"+param);
    }

    //转账
    //chen 2017-01-09
    transfer(param) {
        let url = AppConfig.GetProdUrl() + "/Funds/Transfer";
        return this.httpService.post(url, param);        
    }


}





// WEBPACK FOOTER //
// ./src/services/teammanager.service.ts